import Button from '../../../shared/components/widgets/button';
import AddIcon from '@mui/icons-material/Add';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const FileRegisterButton = ({ isCreateAction, createActionPath }) => {

  const navigate = useNavigate();

  return (
    <Box sx={{ marginLeft: 'auto', maxWidth: '300px'}}>
      {isCreateAction && (
        <Button
          variant="contained" color="secondary"
          /*sx={{ gap: '6px' }}*/
          sx={{ gap: '6px', minWidth: '100px', flexShrink: 0 }}
          onClick={() => {
            if (createActionPath) navigate(createActionPath);
          }}
        >
          <AddIcon />
          <Typography>대용량 파일 등록</Typography>
        </Button>
      )}
    </Box>
  )
}

export default FileRegisterButton;
